import Onboard from '@web3-onboard/core';
import injectedModule from '@web3-onboard/injected-wallets';
import walletConnectModule from '@web3-onboard/walletconnect';

// Despoke SVG logo
const DESPOKE_LOGO_SVG = `
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="180.000000pt" height="180.000000pt" viewBox="0 0 180.000000 180.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
 fill="#000000" stroke="none">
<path d="M340 901 l0 -721 233 0 c385 0 513 18 656 88 146 71 256 215 307 402 28 100 25 329 -4 433 -58 203 -167 338 -347 428 -134 67 -223 80 -557 86 l-288 5 0 -721z m572 648 c135 -29 266 -135 331 -269 64 -131 80 -211 81 -405 1 -115 -4 -189 -13 -230 -9 -35 -16 -52 -18 -40 -38 195 -80 243 -351 406 -239 143 -310 212 -320 308 -7 75 5 118 45 162 66 73 133 92 245 68z m-240 -616 c40 -27 127 -81 193 -120 201 -118 267 -193 269 -303 1 -77 -26 -139 -83 -193 -72 -67 -119 -79 -338 -84 l-183 -5 0 418 0 419 35 -41 c19 -22 67 -63 107 -91z"/>
</g>
</svg>
`;

// Environment variables with validation
const INFURA_ID = process.env.REACT_APP_INFURA_MAINNET_RPC || '';
const WALLETCONNECT_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';
const DAPP_URL = process.env.REACT_APP_DAPP_URL || 'http://localhost:3000';

if (!INFURA_ID || INFURA_ID.includes('your_infura_project_id')) {
  console.warn('⚠️ Invalid Infura RPC URL. Set REACT_APP_INFURA_MAINNET_RPC in .env');
}
if (!WALLETCONNECT_PROJECT_ID) {
  console.warn('⚠️ Missing WalletConnect project ID. Set REACT_APP_WALLETCONNECT_PROJECT_ID in .env');
}

// Configure injected wallets (MetaMask, Phantom, Coinbase, Uniswap, Trust)
const injected = injectedModule({
  filter: {
    'MetaMask': true,
    'Phantom': true,
    'Coinbase Wallet': true,
    'Uniswap Wallet': true,
    'Trust Wallet': true,
  },
  displayUnavailable: false, // Show only installed wallets
});

// Configure WalletConnect for other wallets
const walletConnect = walletConnectModule({
  projectId: WALLETCONNECT_PROJECT_ID || 'fallback_project_id', // Replace with valid ID
  dappUrl: DAPP_URL,
});

// Initialize Web3-Onboard with error handling
let onboard;
try {
  onboard = Onboard({
    wallets: [injected, walletConnect],
    chains: [
      {
        id: '0x1', // Ethereum Mainnet
        token: 'ETH',
        label: 'Ethereum Mainnet',
        rpcUrl: INFURA_ID,
      },
    ],
    appMetadata: {
      name: 'Despoke',
      icon: DESPOKE_LOGO_SVG,
      description: 'Despoke Online Store',
    },
    theme: {
      '--w3o-background-color': '#ffffff',
      '--w3o-foreground-color': '#ffffff',
      '--w3o-text-color': '#1a1a1a',
      '--w3o-border-color': '#d1d5db',
      '--w3o-action-color': '#4A90E2',
      '--w3o-border-radius': '8px',
      '--w3o-font-family': 'Arial, sans-serif',
    },
  });
  console.log('✅ Web3-Onboard initialized successfully');
} catch (error) {
  console.error('❌ Failed to initialize Web3-Onboard:', error);
  throw error;
}

export default onboard;